import {IntlShape} from "react-intl";

/**
 * The first moment (UTC) of a month given as YYYY-MM.
 */
export const monthToDate = (month: string): Date => new Date(month + '-01T00:00:00Z');

/**
 * The first moment (UTC) of a day given as YYYY-MM-DD.
 */
export const dayToDate = (day: string): Date => new Date(day + 'T00:00:00Z');

/**
 * Formats a calendar day of the API, which is given as YYYY-MM-DD (e.g. "2026-03-01"). If the
 * value has a time (ISO 8601), only the date part is used, so the day does not shift with the time
 * zone of the browser.
 */
export function formatDay(intl: IntlShape, value: string | null | undefined): string {
    if (!value) {
        return '–';
    }
    return intl.formatDate(dayToDate(value.slice(0, 10)), {day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'UTC'});
}
